import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { dateFormatter, smevCheckFormatter, smevCheckStatusFormatter } from '../../../utils/formatters';
import { smevCheckApplication } from '../actions';
import { successNotification } from '../../Notifications/notificationDecorator';
import { responseLogWithNotification } from '../../../utils/utils';

export default function SmevChecker(props) {
  const {
    list = [],
    startCheckAction = () => {},
    loadData = () => {},
    current,
  } = props;
  const { formatMessage } = useIntl();
  const [fullscreen, setFullscreen] = useState(false);
  const dispatch = useDispatch();
  const handleRunCheck = checkId => () => {
    dispatch(smevCheckApplication({ checkId })).then(() => {
      successNotification('Повторная проверка', 'Повторная проверка запущена');
    }).catch(responseLogWithNotification);
  };
  const handleRunCheckAll = () => {
    dispatch(startCheckAction(current.id)).then(() => {
      loadData();
      successNotification('Запуск проверок', 'Проверки успешно запущены');
    }).catch(responseLogWithNotification);
  };

  let emptyText = ' ';

  let columns = [
    {
      dataField: 'type',
      text: 'Проверка',
      disableSort: true,
      formatter: smevCheckStatusFormatter,
    },
  ];
  if (fullscreen) {
    columns = [
      {
        dataField: 'type',
        text: 'Проверка',
        disableSort: true,
        headerClassName: 'check-type-name',
        formatter: smevCheckFormatter,
      },
      {
        dataField: 'type',
        text: 'Поставщик информации',
        disableSort: true,
        formatter: t => (t && t.source ? t.source : ''),
      },
      // {
      //   dataField: 'response_date',
      //   text: 'Дата планового ответа',
      //   disableSort: true,
      // },
      {
        dataField: 'responded_at',
        text: 'Дата ответа',
        disableSort: true,
        formatter: dateFormatter,
      },
      {
        dataField: 'report',
        text: 'Отчет',
        disableSort: true,
        headerClassName: 'report-column',
        dataClassName: 'report-column-data',
        formatter: () => <Icons className="grid-button" icon="paper" customIcon />,
      },
      {
        dataField: 'last_smev_log',
        text: 'Запрос',
        disableSort: true,
        headerClassName: 'report-column',
        dataClassName: 'reload-column-data',
        formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_request, `${data.type.name}_request.xml`)} icon="xml_report" customIcon />,
      },
      {
        dataField: 'last_smev_log',
        text: 'Ответ',
        disableSort: true,
        headerClassName: 'report-column',
        dataClassName: 'reload-column-data',
        formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_response, `${data.type.name}_response.xml`)} icon="xml_report" customIcon />,
      },
      {
        dataField: 'id',
        text: 'Обновить',
        disableSort: true,
        headerClassName: 'reload-column',
        dataClassName: 'reload-column-data',
        formatter: id => <Icons onClick={handleRunCheck(id)} className="grid-button" icon="update" customIcon />,
      },
    ];
    emptyText = formatMessage({ id: 'empty.data' });
  }

  return (
    <div className={classNames('afc-data', { fullscreen })}>
      <div className="afc-wrapper">
        <div className="afc-header">
          <div className="afc-header-text">
            Перечень запросов СМЭВ/СМЭВ СПб
          </div>
          <div className="full-screen-button" onClick={() => setFullscreen(!fullscreen)}>
            <Icons
              customIcon
              icon={fullscreen ? 'full-screen-close' : 'full-screen'}
            />
          </div>
        </div>
        <div className="afc-body custom-scroll-theme">
          <div className="grid-wrapper">
            <Grid emptyText={emptyText} data={list} columns={columns} name="profile-list" />
            <div className="null-block" />
          </div>
        </div>
        <div className="application-form-footer">
          <Button onClick={handleRunCheckAll}>{fullscreen ? 'Запустить проверки' : <Icons className="grid-button" icon="update" customIcon />}</Button>
        </div>
      </div>
    </div>
  );
}
